import { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';

import { getColor } from '@customer-portal/shared/helpers/theme-utils';

export const paginatorOverride: PaginatorDesignTokens = {
  navButton: {
    color: getColor('SeaBlue'),
    selectedBackground: getColor('SkyBlue95'),
    selectedColor: getColor('SeaBlue'),
    hoverBackground: getColor('UiLightGray'),
    hoverColor: getColor('UiBlack'),
  },
};
